import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatabaseUpstreamFlowsWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseUpstreamFlowsWithoutPersonalSpaceQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: { id: $databaseId }) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
